import { VerticalNavigation as VerticalNavigation$1 } from '@salesforce/design-system-react';
import cx from 'classnames';
import React from 'react';

function VerticalNavigation({
  className,
  ...props
}) {
  return /*#__PURE__*/React.createElement(VerticalNavigation$1, Object.assign({}, props, {
    className: cx(className, "tds-vertical-navigation")
  }));
}
VerticalNavigation.displayName = "VerticalNavigation";
VerticalNavigation.propTypes = VerticalNavigation$1.propTypes;
VerticalNavigation.defaultProps = VerticalNavigation$1.defaultProps;

export { VerticalNavigation as default };
